'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'arrow-up';
var width = 384;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = ['', 'M186.3 2.3c3.1-3.1 8.2-3.1 11.3 0l176 176c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L200 27.3 200 504c0 4.4-3.6 8-8 8s-8-3.6-8-8L184 27.3 21.7 189.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l176-176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;